export default function LogoArea() {
  return (
    <div className="App-logo">
      <img src="/PREDIVER.svg" alt="logo" />
    </div>
  );
}